

import React from 'react'
import { useNavigate } from 'react-router-dom';

import ScrollableForm from '../components/foundation/ScrollableForm';
import Button from '../components/buttons/Button';
import TextField from '../components/text/TextField';

import Footer from '../components/navigation/Footer'

import '../styles/foundation/NoPage.css';

import { FaArrowRight } from "react-icons/fa";

const NoPage = () => {

  const navigate = useNavigate();  // Initialize useNavigate

  return (
    <ScrollableForm>
        <section className="no-page-section">
            <div className="no-page-container">
                <div className="no-page-title-container">
                    <h1 className="no-page-title">404</h1>
                </div>

                <div className="no-page-subtitle-container">
                    <TextField text="Sorry, this page seems to be having an identity crisis." fontColor="#717C54"/>
                </div>

                <div className="no-page-buttons-container">
                    <Button onClick={() => navigate('/')} disabled={false}>
                        <span>Home</span>
                    </Button>

                    <Button type="light" onClick={() => navigate('/contact')} disabled={false}>
                        Contact Us
                    </Button>
                </div>
            </div>
        </section>

        <Footer/>
    </ScrollableForm>
  )
}

export default NoPage
